import {Image} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import ImageToImageEditProjectPage from './ImageToImageEditProjectPage';
import ImageToImageNewProjectPage from './ImageToImageNewProjectPage';
import ImageToImagePage from './ImageToImagePage';

export const imageToImage: FeatureObject = {
  type: 'feature',
  title: 'Image to Image Generation',
  description: 'Generate images from a source image and prompts in a Google Sheet (OpenAI image edits)',
  IconComponent: Image,
  showFeatureFrontPage: false,
  path: '/image-to-image',
  component: (user) => <ImageToImagePage user={user} />,
  childRoutes: [
    {path: 'new', component: () => <ImageToImageNewProjectPage />},
    {path: 'edit/:id', component: () => <ImageToImageEditProjectPage />},
  ],
  status: FeatureStatus.ADMIN,
  tags: ['image', 'openai', 'sheet', 'drive'],
};
